import gql from 'graphql-tag';
import * as Apollo from '@apollo/client';
import * as Types from '../../../server/graphql/__generated.types';

import { DriveFragmentDoc } from '../fragments.generated';

const defaultOptions = {} as const;
export type UserDrivesQueryVariables = Types.Exact<{
  inputs?: Types.InputMaybe<Types.DrivesInputs>;
}>;

export type UserDrivesQuery = {
  __typename?: 'Query';
  user: {
    __typename?: 'User';
    id: string;
    drives?: Array<{
      __typename?: 'UserDrive';
      id: string;
      teamId?: string | null;
      name: string;
      createdAt: string;
      updatedAt: string;
      driveType: Types.DriveTypeFromDb;
      settings?: { __typename?: 'DriveSettings'; color?: string | null } | null;
      driveAccess: { __typename?: 'DriveAccessRole'; role: Types.DriveAccessRoleEnum };
    }> | null;
  };
};

export type CreateDriveMutationVariables = Types.Exact<{
  inputs: Types.CreateDriveInputs;
}>;

export type CreateDriveMutation = {
  __typename?: 'Mutation';
  createDrive: {
    __typename?: 'CreateDriveMutationResponse';
    code: string;
    success: boolean;
    message: string;
    drive?: {
      __typename?: 'UserDrive';
      id: string;
      teamId?: string | null;
      name: string;
      createdAt: string;
      updatedAt: string;
      driveType: Types.DriveTypeFromDb;
      settings?: { __typename?: 'DriveSettings'; color?: string | null } | null;
      driveAccess: { __typename?: 'DriveAccessRole'; role: Types.DriveAccessRoleEnum };
    } | null;
  };
};

export const UserDrivesDocument = gql`
  query UserDrives($inputs: DrivesInputs) {
    user {
      id
      drives(inputs: $inputs) {
        ...DriveFragment
      }
    }
  }
  ${DriveFragmentDoc}
`;

/**
 * __useUserDrivesQuery__
 *
 * To run a query within a React component, call `useUserDrivesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDrivesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDrivesQuery({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUserDrivesQuery(
  baseOptions?: Apollo.QueryHookOptions<UserDrivesQuery, UserDrivesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UserDrivesQuery, UserDrivesQueryVariables>(
    UserDrivesDocument,
    options
  );
}
export function useUserDrivesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<UserDrivesQuery, UserDrivesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UserDrivesQuery, UserDrivesQueryVariables>(
    UserDrivesDocument,
    options
  );
}
export type UserDrivesQueryHookResult = ReturnType<typeof useUserDrivesQuery>;
export type UserDrivesLazyQueryHookResult = ReturnType<typeof useUserDrivesLazyQuery>;
export type UserDrivesQueryResult = Apollo.QueryResult<
  UserDrivesQuery,
  UserDrivesQueryVariables
>;
export const CreateDriveDocument = gql`
  mutation CreateDrive($inputs: CreateDriveInputs!) {
    createDrive(inputs: $inputs) {
      code
      success
      message
      drive {
        ...DriveFragment
      }
    }
  }
  ${DriveFragmentDoc}
`;
export type CreateDriveMutationFn = Apollo.MutationFunction<
  CreateDriveMutation,
  CreateDriveMutationVariables
>;

/**
 * __useCreateDriveMutation__
 *
 * To run a mutation, you first call `useCreateDriveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDriveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDriveMutation, { data, loading, error }] = useCreateDriveMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreateDriveMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDriveMutation,
    CreateDriveMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateDriveMutation, CreateDriveMutationVariables>(
    CreateDriveDocument,
    options
  );
}
export type CreateDriveMutationHookResult = ReturnType<typeof useCreateDriveMutation>;
export type CreateDriveMutationResult = Apollo.MutationResult<CreateDriveMutation>;
export type CreateDriveMutationOptions = Apollo.BaseMutationOptions<
  CreateDriveMutation,
  CreateDriveMutationVariables
>;
